<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    class="side_bar"
    style="margin-top: 120px !important;"
  >


    <CRenderFunction flat :content-to-render="navoptions" :style="{'background-color': loggedInUser.sidebar_color ? loggedInUser.sidebar_color : '#3c4b64', 'color': 'white' }" :class="loggedInUser.sidebar_txt_color ? 'custome-sidebar-' + loggedInUser.sidebar_txt_color : 'custome-sidebar-default' " />   


    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
      :style="{'background-color': loggedInUser.sidebar_mini_color ? loggedInUser.sidebar_mini_color : '#001533' }"
    />
  </CSidebar>
</template>

<script>
import { mapGetters } from 'vuex';

import nav from './_nav'
import axios from "axios";
import i18n from '@/plugins/i18n';

export default {
  name: 'TheSidebar',
  components: {
      i18n
  },
  data(){
    return {
      navoptions: [],
      lang: {
        'Auto Tip/Cash': {
            'en': 'Auto Tip/Cash',
            'it': 'Auto Tip/Cash',
            'es': 'Auto Tip/Cash',
            'pt': 'Auto Tip/Cash',
            'fr': 'Auto Tip/Cash',
            'ru': 'Auto Tip/Cash',
            'de': 'Auto Tip/Cash'
        },
        // '"My Tips and Stats': {
        //     'en': 'My Tips and Stats',
        //     'it': 'My Tips and Stats',
        //     'es': 'My Tips and Stats',
        //     'pt': 'Minhas tips e Estatísticas',
        //     'fr': 'My Tips and Stats',
        //     'ru': 'My Tips and Stats',
        //     'de': 'My Tips and Stats',
        // },
        'Tutorials/home': {
            'en': 'Tutorials/home',
            'it': 'Guide/home',
            'es': 'Tutorials/home',
            'pt': 'Tutoriais/home',
            'fr': 'Tutorials/home',
            'ru': 'Tutorials/home',
            'de': 'Tutorials/home'
        },
        'Dashboard': {
            'en': 'Dashboard',
            'it': 'Dashboard',
            'es': 'Dashboard',
            'pt': 'Dashboard',
            'fr': 'Dashboard',
            'ru': 'Dashboard',
            'de': 'Dashboard'
        },
        'Main': {
             'en': 'Sospeso WEB',
             'it': 'Sospeso WEB',
             'es': 'Sospeso WEB',
             'pt': 'Sospeso WEB',
             'fr': 'Sospeso WEB',
             'ru': 'Sospeso WEB',
             'de': 'Sospeso WEB'
          },

        'liveStatsNew': {
             'en': 'Live stats',
             'it': 'In Live stats',
             'es': 'Live stats',
             'pt': 'Ao vivo',
             'fr': 'Live stats',
             'ru': 'Live stats',
             'de': 'Live stats'
          },

          'AdminView': {
             'en': 'Admin settings',
             'it': 'Opzioni admin',
             'es': 'Opzioni admin',
             'pt': 'Configuracoes admin',
             'fr': 'Admin settings',
             'ru': 'Admin settings',
             'de': 'Admin settings'
          },

          'Cold Stats': {
             'en': 'Cold stats',
             'it': 'Statistiche prematch',
             'es': 'Statistiche prematch',
             'pt': 'Estatísticas pré-jogo',
             'fr': 'Cold stats',
             'ru': 'Cold stats',
             'de': 'Cold stats'
          },

          'League Table': {
             'en': 'League tables',
             'it': 'League tables',
             'es': 'League tables',
             'pt': 'Tabelas das ligas',
             'fr': 'League tables',
             'ru': 'League tables',
             'de': 'League tables'
          },

          'Value stats data': {
             'en': 'Value bets',
             'it': 'Value bets',
             'es': 'Value bets',
             'pt': 'Apostas de valor',
             'fr': 'Value bets',
             'ru': 'Value bets',
             'de': 'Value bets'
          },

          'Live Stats Analysis': {
             'en': 'Live Stats Analysis',
             'it': 'Live Stats Analysis',
             'es': 'Live Stats Analysis',
             'pt': 'Live Stats Analysis',
             'fr': 'Live Stats Analysis',
             'ru': 'Live Stats Analysis',
             'de': 'Live Stats Analysis'
          },

          'Live Stats Analysis 1': {
             'en': 'Search stats',
             'it': 'Ricerca Stats',
             'es': 'Search stats',
             'pt': 'Pesquisar Estatisticas',
             'fr': 'Search stats',
             'ru': 'Search stats',
             'de': 'Search stats'
          },

          'Prediction Stats': {
             'en': 'Prediction Stats',
             'it': 'Prediction Stats',
             'es': 'Prediction Stats',
             'pt': 'Prediction Stats',
             'fr': 'Prediction Stats',
             'ru': 'Prediction Stats',
             'de': 'Prediction Stats'
          },

          'Team Analysis': {
             'en': 'Team Analysis',
             'it': 'Analisi Squadre',
             'es': 'Team Analysis',
             'pt': 'Análise de time',
             'fr': 'Team Analysis',
             'ru': 'Team Analysis',
             'de': 'Team Analysis'
          },

          'Historic Data': {
             'en': 'Historic Odds',
             'it': 'Storico quote',
             'es': 'Historic Odds',
             'pt': 'Histórico de cotas',
             'fr': 'Historic Odds',
             'ru': 'Historic Odds',
             'de': 'Historic Odds'
          },

          'Prediction Upload': {
             'en': 'Prediction Upload',
             'it': 'Prediction Upload',
             'es': 'Prediction Upload',
             'pt': 'Prediction Upload',
             'fr': 'Prediction Upload',
             'ru': 'Prediction Upload',
             'de': 'Prediction Upload'
          },

          'Nav Dashboard': {
             'en': 'Sospeso Dashboard',
             'it': 'Sospeso Dashboard',
             'es': 'Sospeso Dashboard',
             'pt': 'Sospeso Dashboard',
             'fr': 'Sospeso Dashboard',
             'ru': 'Sospeso Dashboard',
             'de': 'Sospeso Dashboard'
          },

          'Today': {
             'en': 'Today',
             'it': 'Oggi',
             'es': 'Hoy',
             'pt': 'Hoje',
             'fr': "Aujourd'hui",
             'ru': 'Сегодня',
             'de': 'Heute'
          },

          'Money Manage': {
             'en': 'Money Management',
             'it': 'Gestione cassa',
             'es': 'Money Management',
             'pt': 'Gestão dinheiro',
             'fr': 'Money Management',
             'ru': 'Money Management',
             'de': 'Money Management'
          },

          'Page Setting': {
             'en': 'Page Settings',
             'it': 'Opzioni pagine',
             'es': 'Page Setting',
             'pt': 'Configurações páginas',
             'fr': 'Page Setting',
             'ru': 'Page Setting',
             'de': 'Page Setting'
          },
          'Alerts': {
             'en': 'Alerts',
             'it': 'Segnali',
             'es': 'Alerts',
             'pt': 'Alertas',
             'fr': 'Alerts',
             'ru': 'Alerts',
             'de': 'Alerts'
          },
          'User List Page': {
             'en': 'Users',
             'it': 'Utenti',
             'es': 'Users',
             'pt': 'Usuários',
             'fr': 'Users',
             'ru': 'Users',
             'de': 'Users'
          },
          'Post a tip': {
             'en': 'Post a tip',
             'it': 'Posta tip',
             'es': 'Post a tip',
             'pt': 'Postar tip',
             'fr': 'Post a tip',
             'ru': 'Post a tip',
             'de': 'Post a tip'
          },

          'League Stats': {
             'en': 'League Stats',
             'it': 'Statistiche di Lega',
             'es': 'League Stats',
             'pt': 'Estatísticas das Ligas',
             'fr': 'League Stats',
             'ru': 'League Stats',
             'de': 'League Stats'
          },
          'Betfair': {
             'en': 'Betfair',
             'it': 'Betfair',
             'es': 'Betfair',
             'pt': 'Betfair',
             'fr': 'Betfair',
             'ru': 'Betfair',
             'de': 'Betfair'
          },
          'subscription_logo': {
             'en': 'subscription_logo',
             'it': 'subscription_logo',
             'es': 'subscription_logo',
             'pt': 'subscription_logo',
             'fr': 'subscription_logo',
             'ru': 'subscription_logo',
             'de': 'subscription_logo'
          },
          'investments': {
            'en': 'investments',
             'it': 'Investimenti',
             'es': 'investments',
             'pt': 'Investimentos',
             'fr': 'investments',
             'ru': 'investments',
             'de': 'investments'
          },
          'Prova Page': {
            'en': 'prova page en',
             'it': 'prova page it',
             'es': 'investments',
             'pt': 'Investimentos',
             'fr': 'investments',
             'ru': 'investments',
             'de': 'investments'
          }
      }
    }
  },
  computed: {
    ...mapGetters('notifications', {
      allInfo: 'info'
    }),
    ...mapGetters(['loggedInUser']),
    
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
  methods: {
    resetnav() {
      
      var admin = localStorage.getItem("admin");
      var membership_level = localStorage.getItem("membership_level");
      

      var icon_content = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" class="c-sidebar-nav-icon" style="fill: icon_color"><path d="M19.955 4.045c-2.036-2.039-4.851-3.3-7.959-3.3-6.213 0-11.25 5.037-11.25 11.25 0 3.109 1.261 5.923 3.299 7.959l0 0c2.036 2.039 4.851 3.3 7.959 3.3 6.213 0 11.25-5.037 11.25-11.25 0-3.109-1.261-5.923-3.299-7.959l-0-0zM19.746 6.086c1.175 1.52 1.913 3.431 1.995 5.511l0.001 0.019-3.1-2.333zM14.814 2.665l-2.736 2.033-2.865-2.041c0.834-0.258 1.794-0.407 2.788-0.407 1.004 0 1.972 0.152 2.883 0.433l-0.069-0.018zM5.475 9.283l-3.217 2.357c0.078-2.121 0.826-4.053 2.036-5.606l-0.016 0.022zM4.041 17.625h3.72l1.174 3.631c-2.022-0.688-3.697-1.954-4.874-3.601l-0.020-0.030zM10.64 21.655l-1.788-5.53h-5.685c-0.377-0.782-0.661-1.69-0.805-2.643l-0.007-0.054 4.92-3.604-1.858-5.009c0.621-0.572 1.326-1.069 2.089-1.468l0.054-0.026 4.537 3.231 4.347-3.23c0.82 0.427 1.527 0.927 2.158 1.508l-0.007-0.006-1.727 5 4.779 3.596c-0.151 1.009-0.435 1.92-0.838 2.762l0.025-0.058h-5.481l-1.971 5.527c-0.415 0.063-0.894 0.098-1.381 0.098-0.48 0-0.951-0.035-1.413-0.102l0.053 0.006zM15.121 21.238l1.288-3.613h3.55c-1.186 1.661-2.84 2.919-4.769 3.592l-0.069 0.021z"></path><path d="M16.257 10.473l-4.17-3.030-4.17 3.030 1.593 4.902h5.154zM13.574 13.875h-2.975l-0.919-2.829 2.406-1.748 2.406 1.748z"></path></svg>'

      const name = nav[0]['_name'];
      // const list = [...nav[0]['_children']];
      let list = []

      nav[0]['_children'].forEach((item) => {
        list.push(item)
      })

      console.log(nav)

      
      let apiURL = `${process.env.VUE_APP_URL}api/pagesetting/list`;
      axios
      .get(apiURL)
      .then((res) => {
        var Pages = res.data;
        
        var Pages_dic = {};
        var Pages_dic_hide = {};
        var Colors_dic = {};
        var i;
        
        for (i = 0; i < Pages.length; i++) {
          let page_name = Pages[i].name;
          if (page_name == "Auto Tip Cash")
            page_name = "Auto Tip/Cash";

          Colors_dic[page_name] = Pages[i].color
          if (!Pages[i].setting)
            continue
          
          Pages[i].membership_setting.forEach((item) =>{
            if (item.name == membership_level){

              Pages_dic[page_name] = item.value
              
            }
          });
          Pages[i].membership_setting_hide.forEach((item) =>{
            if (item.name == membership_level){

              Pages_dic_hide[page_name] = item.value
              
            }
          })   
          
        }
        if (admin == 'false') {
          let name_keys = Object.keys(Pages_dic)
          
          var j;
          var deleted = 0;

          let _list = [];
          let _list_hidden = [];

          for (j = 0; j < list.length; j++) {
            if ( list[j].to == "/auto_post_tip")
              continue;
            if (name_keys.includes(list[j]['en_name'])) {
              if ( Pages_dic[list[j]['en_name']] ) {
                var content = icon_content.replace('icon_color', Colors_dic[list[j]['en_name']])

                  var new_item = {}
                  new_item['en_name'] = list[j].en_name
                  new_item['name'] = list[j].name
                  new_item['_name'] = list[j]._name
                  new_item['to'] = list[j].to
                  new_item['badge'] = list[j].badge 
                  new_item['icon'] = {customClasses: 'ord-ball', size: 'custom', content: content}
                _list = [..._list, new_item];
              }
              else {
                  if ( !Pages_dic_hide[list[j]['en_name']] ) 
                    continue;

                  var new_item = {}
                  new_item['en_name'] = list[j].en_name
                  new_item['name'] = list[j].name
                  new_item['_name'] = list[j]._name
                  new_item['badge'] = list[j].badge
                  new_item['to'] = '/membership'
                  new_item['icon'] = {name: 'cil-lock-locked', customClasses: 'lock', size: 'custom'}
                
                _list_hidden = [..._list_hidden, new_item];
              }
            }
            
          }

          var total_list = _list.concat(_list_hidden)          

          this.navoptions = [{_name: name, _children: total_list}];
          for (var i = 0; i < this.navoptions[0]._children.length; i++) {        
            
            var nav_name = this.navoptions[0]._children[i].en_name;           
            this.navoptions[0]._children[i].name = this.lang[nav_name][i18n.locale];           
            
          }
        }
        else {
          let admin_list = []
          for (j = 0; j < list.length; j++) {
            console.log(list[j].to)
            if ( list[j].to == "/auto_post_tip_user")
              continue;
            console.log(Colors_dic[list[j]['en_name']])
              
            var content = icon_content.replace('icon_color', Colors_dic[list[j]['en_name']])

            var new_item = {}
            new_item['en_name'] = list[j].en_name
            new_item['name'] = list[j].name
            new_item['_name'] = list[j]._name
            new_item['to'] = list[j].to
            new_item['badge'] = list[j].badge
            new_item['icon'] = {customClasses: 'ord-ball', size: 'custom', content: content}
            admin_list = [...admin_list, new_item];
          }
          this.navoptions = [{_name: name, _children: [...admin_list]}];
          for (var i = 0; i < this.navoptions[0]._children.length; i++) {           
            var nav_name = this.navoptions[0]._children[i].en_name;           
            this.navoptions[0]._children[i].name = this.lang[nav_name][i18n.locale];
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });     
      
    }
    
  },  
  created() {
    if (localStorage.getItem('lang') == null || localStorage.getItem('lang') == '') {
      console.log('lang response1')
          var user_id = localStorage.getItem('user_id');
          var xhr0 = new XMLHttpRequest();
          var self = this;
          xhr0.onreadystatechange = function(){
              if (xhr0.readyState === 4){
                  console.log('lang response2')
                  var response = JSON.parse(xhr0.responseText);
                  
                  console.log('lang response',response)
                  if(response.hasOwnProperty('mylang')){
                    localStorage.setItem('lang', response.mylang);

                  }
                  else {
                    localStorage.setItem('lang', 'en');

                  }
                  i18n.locale = localStorage.getItem('lang')
                  self.resetnav();
              }
          };

          var data = {user_id: user_id}

          xhr0.open('GET', `${process.env.VUE_APP_URL}get_usersetting/${user_id}`, true);
          // xhr.setRequestHeader("Content-type", "application/json");
          xhr0.send()
    }
    else {
      console.log('lang', localStorage.getItem('lang'))
      i18n.locale = localStorage.getItem('lang')
      console.log('i18n.locale', i18n.locale)
      this.resetnav();
    }
  },
  beforeMount(){
    
  },
  mounted () {
    
  },
  watch: {
    'allInfo.totalFeeds': {
      deep: true,
      immediate: true,
      handler(val) {
        if(this.navoptions.length > 0) {
          let fIndex = this.navoptions[0]._children.findIndex(nItem => nItem.to === '/feed_page');
          if(fIndex > -1)
            this.navoptions[0]._children[fIndex].badge = {
              color: 'primary',
              text: `${this.allInfo.totalFeeds}`
            };
        }
      }
    }
  }
}
</script>
<style>
  .red {
    fill: red;
  }
  .c-sidebar {

  }
  .lock {
    width: 20px;
      margin-right: 10px;
      fill:  gray;
      position: absolute;
      left:  15px; 
  }
  .ball {
    width: 20px;
      margin-right: 10px;
      fill:  #ffff99;
      position: absolute;
      left:  15px; 
  }
  .ord-ball {
    width: 20px;
      margin-right: 10px;
      position: absolute;
      left:  15px; 
  }
  .c-sidebar-nav-link {
    padding-left: 55px;
    padding-right: 0px !important;
  }
  .c-sidebar-nav-link > span{
    margin-left: 30px !important;
  }
  .custome-sidebar-red a {
    color: red !important;
  }
  .custome-sidebar-red a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-white a {
    color: white !important;
  }
  .custome-sidebar-white a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-black a {
    color: black !important;
  }
  .custome-sidebar-black a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-gray a {
    color: gray !important;
  }
  .custome-sidebar-gray a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-green a {
    color: green !important;
  }
  .custome-sidebar-green a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-yellow a {
    color: yellow !important;
  }
  .custome-sidebar-yellow a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-blue a {
    color: blue !important;
  }
  .custome-sidebar-blue a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-purple a {
    color: purple !important;
  }
  .custome-sidebar-purple a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-orange a {
    color: orange !important;
  }
  .custome-sidebar-orange a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-pink a {
    color: pink !important;
  }
  .custome-sidebar-pink a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-silver a {
    color: silver !important;
  }
  .custome-sidebar-silver a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-maroon a {
    color: maroon !important;
  }
  .custome-sidebar-maroon a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-fuchsia a {
    color: fuchsia !important;
  }
  .custome-sidebar-fuchsia a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-lime a {
    color: lime !important;
  }
  .custome-sidebar-lime a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-olive a {
    color: olive !important;
  }
  .custome-sidebar-olive a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-navy a {
    color: navy !important;
  }
  .custome-sidebar-navy a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-teal a {
    color: teal !important;
  }
  .custome-sidebar-teal a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-aqua a {
    color: aqua !important;
  }
  .custome-sidebar-aqua a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-yellowgreen a {
    color: yellowgreen !important;
  }
  .custome-sidebar-yellowgreen a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-skyblue a {
    color: skyblue !important;
  }
  .custome-sidebar-skyblue a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-lightgray a {
    color: lightgray !important;
  }
  .custome-sidebar-lightgray a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-lightblue a {
    color: lightblue !important;
  }
  .custome-sidebar-lightblue a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-lightred a {
    color: lightred !important;
  }
  .custome-sidebar-lightred a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-lightpurple a {
    color: lightpurple !important;
  }
  .custome-sidebar-lightpurple a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-lightgreen a {
    color: lightgreen !important;
  }
  .custome-sidebar-lightgreen a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-lightpink a {
    color: lightpink !important;
  }
  .custome-sidebar-lightpink a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-lightyellow a {
    color: lightyellow !important;
  }
  .custome-sidebar-lightyellow a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-darkgray a {
    color: darkgray !important;
  }
  .custome-sidebar-darkgray a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-darkgreen a {
    color: darkgreen !important;
  }
  .custome-sidebar-darkgreen a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-darkred a {
    color: darkred !important;
  }
  .custome-sidebar-darkred a:hover {
    color: white !important;
    background-color: blue !important;
  }

  .custome-sidebar-darkblue a {
    color: darkblue !important;
  }
  .custome-sidebar-darkblue a:hover {
    color: white !important;
    background-color: blue !important;
  }
  .custome-sidebar-darkorange a {
    color: darkorange !important;
  }
  .custome-sidebar-darkorange a:hover {
    color: white !important;
    background-color: blue !important;
  }

</style>